import * as React from 'react'
import { clsx } from 'clsx'

import styles from './OverlayArrow.module.css'

/**
 * Internal component to render the arrow of the overlay content,
 * such as hover card, menu or popover
 */
type OverlayArrowProps = React.ComponentPropsWithoutRef<'div'> & {
  size?: number
}

interface OverlayArrowCssProperties extends React.CSSProperties {
  '--arrow-size': string
}

const OverlayArrow = React.forwardRef<
  React.ElementRef<'div'>,
  OverlayArrowProps
>(({ size = 16, className, ...props }, ref) => {
  const arrowStyle: OverlayArrowCssProperties = {
    '--arrow-size': size + 'px',
  }

  return (
    <div
      ref={ref}
      data-arrow={true}
      {...props}
      className={clsx(styles.arrow, className)}
      style={arrowStyle}
    />
  )
})

OverlayArrow.displayName = 'OverlayArrow'

export { OverlayArrow }
export type { OverlayArrowProps }
